export default "images/车灯开启情况-车门开启.png";